import React, { useState } from "react";
import { ImageLightbox } from "./ImageLightbox";
import type { ProjectImage } from "@/features/gebreken/hooks/useProjectImages";

interface GebrekenImageGalleryProps {
  images: ProjectImage[];
  bevindingId: string;
}

/**
 * Thumbnail grid for displaying images in a bevinding card.
 * Shows 4-column grid with 96x96px thumbnails.
 * Click thumbnail to open lightbox.
 */
export const GebrekenImageGallery: React.FC<GebrekenImageGalleryProps> = ({
  images,
  bevindingId,
}) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const handleThumbnailClick = (index: number) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {images.map((image, index) => (
          <button
            key={image.name}
            type="button"
            onClick={() => handleThumbnailClick(index)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleThumbnailClick(index);
              }
            }}
            className="relative w-16 h-16 overflow-hidden bg-muted cursor-pointer hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-primary"
            aria-label={`Open image ${index + 1} of ${images.length}`}
          >
            <img
              src={image.downloadUrl}
              alt={`Foto ${index + 1}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <ImageLightbox
          images={images}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
};
